import { render, staticRenderFns } from "./TrackingPurchaseOrder.vue?vue&type=template&id=f0967f3c&scoped=true"
import script from "./TrackingPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./TrackingPurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./TrackingPurchaseOrder.vue?vue&type=style&index=0&id=f0967f3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0967f3c",
  null
  
)

export default component.exports